export const FILTER_TIP_ID = 'filterTip';
export const MAX_FIRST_NUMBER_FACES_IN_FILTER = 5;
